import { render, staticRenderFns } from "./AddUpdateSidebar.vue?vue&type=template&id=48fde6c2&scoped=true&"
import script from "./AddUpdateSidebar.vue?vue&type=script&lang=js&"
export * from "./AddUpdateSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdateSidebar.vue?vue&type=style&index=0&id=48fde6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fde6c2",
  null
  
)

export default component.exports